import React from "react";

import { CssBaseline, Grid, Container, Typography } from "@material-ui/core";

import Formulario from "../../parametros/formulas";
import FormularioNotif from "../../parametros/notificaciones";

//styles
import useStyles from "./styles";

export default function ParametrosView() {
  const classes = useStyles();

  return (
    <div className={classes.root} id="Precalificar">
      <CssBaseline />

      <main className={classes.content}>
        <Container maxWidth="md" className={classes.container}>
          <CssBaseline />
          <Grid container direction="column" justifyContent="space-evenly">
            <Typography
              className={classes.TituloForm}
              variant="h4"
              color="secondary"
              align="left"
              gutterBottom
            >
              Parametros
            </Typography>
            <Typography
              className={classes.TituloForm}
              variant="h6"
              color="primary"
              align="left"
              gutterBottom
            >
              Formulas
            </Typography>

            <Formulario />
            <Typography
              className={classes.TituloForm}
              variant="h6"
              color="primary"
              align="left"
              gutterBottom
            >
              Notificaciones
            </Typography>
            <FormularioNotif />
          </Grid>
        </Container>
      </main>
    </div>
  );
}
